<template>
  <div class="event-view">
    <h2>Initiate Events</h2>
    <form @submit.prevent="addEvent">
      <label>
        Event Name:
        <input
                type="text"
                class="form-control"
                autocomplete="off"
                placeholder="Event Name"
                @input="updateEventsId()"
                @change="updateEventsId()"
                v-model="selectedEvent"
                list="events-list"
                id="inpsel_equipid"
              />
              <datalist id="events-list">
                <option
                  :value="event.name"
                  :data-id="event.id"
                  v-for="event in events"
                  :key="event"
                >
                  {{ event.name }}
                </option>
              </datalist>
      </label>
      <label>
        Date:
        <input v-model="eventDate" type="date" required />
      </label>
      <label>
        Time:
        <input v-model="eventTime" type="time" required />
      </label>
      <button type="submit">Add Event</button>
    </form>
    
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { reg } from "../../services/regions-services";
// const eventName = ref("");
const eventDate = ref("");
const eventTime = ref("");
const events = ref([]);
const selectedEvent = ref([]);


const updateEventsId = () => {
      const select = document.querySelector("#events-list");
      const selectedOption = Array.from(select.options).find(
        (opt) => opt.value === selectedEvent.value
      );
      if (selectedOption) {
        this.model.equipment_id = parseInt(selectedOption.getAttribute("data-id"));
      }
    }
// function formatDate(dateStr) {
//   if (!dateStr) return "";
//   const options = { year: "numeric", month: "long", day: "numeric" };
//   return new Date(dateStr).toLocaleDateString(undefined, options);
// }

// function formatTime(timeStr) {
//   if (!timeStr) return "";
//   const [hour, minute] = timeStr.split(":");
//   const date = new Date();
//   date.setHours(hour, minute);
//   return date.toLocaleTimeString(undefined, {
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }



onMounted(async ()=> {
  console.log("Pakita dapat dito mga eventss")
 events.value = await reg.getRecords("GameEvents");
  console.log(events.value)
})
</script>

<style scoped>
.event-view {
  max-width: 400px;
  margin: 2rem auto;
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.event-view h2,
.event-view h3 {
  margin-bottom: 1rem;
  color: #333;
}

.event-view form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.event-view form label {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  color: #444;
}

.event-view form label input {
  margin-top: 0.5rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.event-view form button {
  align-self: flex-end;
  padding: 0.5rem 1.5rem;
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}

.event-view form button:hover {
  background: #1565c0;
}

.event-list {
  margin-top: 2rem;
}

.event-list ul {
  list-style: none;
  padding: 0;
}

.event-list li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.event-list li strong {
  color: #1976d2;
}
</style>
